import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const StagedFailedIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props} viewBox="0 0 29 29" fill="none">
      <path
        d="M11.6605 3.05958C11.9164 2.96706 12.2011 2.98225 12.4476 3.10548L20.4476 7.10548C20.7864 7.27487 21.0003 7.62124 21.0003 8.00001C21.0003 8.37878 20.7864 8.72515 20.4476 8.89454L12.4476 12.8945C12.1661 13.0353 11.8346 13.0353 11.553 12.8945L3.55305 8.89454C3.21426 8.72515 3.00031 8.37878 3.00031 8.00001C3.00031 7.62124 3.21426 7.27487 3.55305 7.10548L11.553 3.10548L11.6605 3.05958ZM6.23664 8.00001L12.0003 10.8818L17.764 8.00001L12.0003 5.11817L6.23664 8.00001Z"
        fill="#8B9397"
      />
      <path
        d="M19.553 11.1055C20.047 10.8585 20.6479 11.0588 20.8948 11.5527C21.1418 12.0467 20.9416 12.6475 20.4476 12.8945L12.4476 16.8945C12.1661 17.0353 11.8346 17.0353 11.553 16.8945L3.55305 12.8945C3.05907 12.6475 2.85879 12.0467 3.10578 11.5527C3.35277 11.0588 3.9536 10.8585 4.44758 11.1055L12.0003 14.8818L19.553 11.1055Z"
        fill="#8B9397"
      />
      <path
        d="M19.553 15.1055C20.047 14.8585 20.6479 15.0588 20.8948 15.5527C21.1418 16.0467 20.9416 16.6475 20.4476 16.8945L12.4476 20.8945C12.1661 21.0353 11.8346 21.0353 11.553 20.8945L3.55305 16.8945C3.05907 16.6475 2.85879 16.0467 3.10578 15.5527C3.35277 15.0588 3.9536 14.8585 4.44758 15.1055L12.0003 18.8818L19.553 15.1055Z"
        fill="#8B9397"
      />
      <circle
        cx="5"
        cy="5"
        r="5"
        fill="var(--color-fire-600)"
        style={{ transform: "translate(15px, 16px)" }}
      ></circle>
    </Icon>
  );
};
